import cookie from 'react-cookie';
import * as userApi from '../common/api/user';
import { getUserFavorites } from '../selectors/user';

export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const FETCH_USER_ENTITLEMENTS = 'FETCH_USER_ENTITLEMENTS';
export const FETCH_USER_ENTITLEMENTS_SUCCESS = 'FETCH_USER_ENTITLEMENTS_SUCCESS';
export const FETCH_USER_ENTITLEMENTS_FAILURE = 'FETCH_USER_ENTITLEMENTS_FAILURE';

export const CREATE_USER_FAVORITE = 'CREATE_USER_FAVORITE';
export const CREATE_USER_FAVORITE_SUCCESS = 'CREATE_USER_FAVORITE_SUCCESS';
export const CREATE_USER_FAVORITE_FAILURE = 'CREATE_USER_FAVORITE_FAILURE';

export const FETCH_USER_FAVORITES = 'FETCH_USER_FAVORITES';
export const FETCH_USER_FAVORITES_SUCCESS = 'FETCH_USER_FAVORITES_SUCCESS';
export const FETCH_USER_FAVORITES_FAILURE = 'FETCH_USER_FAVORITES_FAILURE';

export const EDIT_USER_FAVORITE = 'EDIT_USER_FAVORITE';
export const RESET_USER_FAVORITE = 'RESET_USER_FAVORITE';

export const UPDATE_USER_FAVORITE = 'UPDATE_USER_FAVORITE';
export const UPDATE_USER_FAVORITE_SUCCESS = 'UPDATE_USER_FAVORITE_SUCCESS';
export const UPDATE_USER_FAVORITE_FAILURE = 'UPDATE_USER_FAVORITE_FAILURE';

export const UPDATE_USER_FAVORITES = 'UPDATE_USER_FAVORITES';
export const UPDATE_USER_FAVORITES_SUCCESS = 'UPDATE_USER_FAVORITES_SUCCESS';
export const UPDATE_USER_FAVORITES_FAILURE = 'UPDATE_USER_FAVORITES_FAILURE';

export const DELETE_USER_FAVORITE = 'DELETE_USER_FAVORITE';
export const DELETE_USER_FAVORITE_SUCCESS = 'DELETE_USER_FAVORITE_SUCCESS';
export const DELETE_USER_FAVORITE_FAILURE = 'DELETE_USER_FAVORITE_FAILURE';

export const USER_FAVORITES_ACTIVE = 'USER_FAVORITES_ACTIVE';

export const USER_FAVORITES_NEW_INVALID = 'USER_FAVORITES_NEW_INVALID';

export const SAVE_USER_FAVORITE = 'SAVE_USER_FAVORITE';
export const SAVE_USER_FAVORITE_SUCCESS = 'SAVE_USER_FAVORITE_SUCCESS';
export const SAVE_USER_FAVORITE_FAILURE = 'SAVE_USER_FAVORITE_FAILURE';

export const FETCH_PAYMENT_WARNINGS = 'FETCH_PAYMENT_WARNINGS';
export const FETCH_PAYMENT_WARNINGS_SUCCESS = 'FETCH_PAYMENT_WARNINGS_SUCCESS';
export const FETCH_PAYMENT_WARNINGS_FAILURE = 'FETCH_PAYMENT_WARNINGS_FAILURE';

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS';
export const FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS';
export const FETCH_USER_SETTINGS_FAILURE = 'FETCH_USER_SETTINGS_FAILURE';

export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_USER_LOCATION_SUCCESS = 'SET_USER_LOCATION_SUCCESS';
export const SET_USER_LOCATION_FAILURE = 'SET_USER_LOCATION_FAILURE';

export const SET_DFP_AD_ATTRIBUTES = 'SET_DFP_AD_ATTRIBUTES';
export const SET_DFP_AD_ATTRIBUTES_SUCCESS = 'SET_DFP_AD_ATTRIBUTES_SUCCESS';
export const SET_DFP_AD_ATTRIBUTES_FAILURE = 'SET_DFP_AD_ATTRIBUTES_FAILURE';

export const SET_USER_BW_WIND_WAVE_MODEL = 'SET_USER_BW_WIND_WAVE_MODEL';
export const SET_USER_BW_WIND_WAVE_MODEL_SUCCESS = 'SET_USER_BW_WIND_WAVE_MODEL_SUCCESS';
export const SET_USER_BW_WIND_WAVE_MODEL_FAILURE = 'SET_USER_BW_WIND_WAVE_MODEL_FAILURE';

export const SET_USER_BW_UNIT_PREFERENCE = 'SET_USER_BW_UNIT_PREFERENCE';
export const SET_USER_BW_UNIT_PREFERENCE_SUCCESS = 'SET_USER_BW_UNIT_PREFERENCE_SUCCESS';
export const SET_USER_BW_UNIT_PREFERENCE_FAILURE = 'SET_USER_BW_UNIT_PREFERENCE_FAILURE';

export const fetchUserDetails = userDetails => async (dispatch) => {
  dispatch({ type: FETCH_USER_DETAILS });

  try {
    const details = userDetails || await userApi.fetchUserDetails();
    dispatch({
      type: FETCH_USER_DETAILS_SUCCESS,
      details,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_DETAILS_FAILURE,
      error: err,
    });
  }
};

export const fetchUserEntitlements = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_ENTITLEMENTS });

  try {
    const { entitlements, legacyEntitlements } = await userApi.fetchUserEntitlements();
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_SUCCESS,
      entitlements,
      legacyEntitlements,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_FAILURE,
      error: err,
    });
  }
};

export const createUserFavorite = favorite => async (dispatch) => {
  dispatch({
    type: CREATE_USER_FAVORITE,
  });

  try {
    await userApi.createUserFavorite(favorite);

    dispatch({
      type: CREATE_USER_FAVORITE_SUCCESS,
      favorite,
    });
  } catch ({ message: error }) {
    dispatch({
      type: CREATE_USER_FAVORITE_FAILURE,
      error,
    });
  }
};

export const fetchUserFavorites = userDetails => async (dispatch) => {
  dispatch({ type: FETCH_USER_FAVORITES });

  try {
    const { favorites } = await userApi.fetchUserFavorites(userDetails);
    dispatch({
      type: FETCH_USER_FAVORITES_SUCCESS,
      favorites,
    });
  } catch ({ message: error }) {
    dispatch({
      type: FETCH_USER_FAVORITES_FAILURE,
      error,
    });
  }
};

export const editUserFavorite = (id, value) => (dispatch, getState) => {
  const favorite = getUserFavorites(getState()).find(fav => fav._id === id);

  dispatch({
    type: EDIT_USER_FAVORITE,
    favorite: {
      ...favorite,
      name: value,
    },
  });
};

export const resetUserFavorite = id => (dispatch) => {
  dispatch({
    type: RESET_USER_FAVORITE,
    id,
  });
};

export const updateUserFavorite = id => async (dispatch, getState) => {
  dispatch({ type: UPDATE_USER_FAVORITE });

  const state = getState();
  const { details } = state;
  const favorite = getUserFavorites(state).find(item => item._id === id);
  const body = { name: favorite.name };

  try {
    const { message } = await userApi.updateUserFavorite(id, body, details);

    if (message && message === 'OK') {
      dispatch({
        type: UPDATE_USER_FAVORITE_SUCCESS,
        id,
      });

      return message;
    }

    throw new Error('Error updating favorite');
  } catch ({ message: error }) {
    dispatch({
      type: UPDATE_USER_FAVORITE_FAILURE,
      error,
    });
  }
};

export const rankUserFavorite = (id, rank) => async (dispatch, getState) => {
  const currentFavorites = getUserFavorites(getState());
  const [changedFavorite, ...favorites] = currentFavorites.reduce((all, currentFav) => (
    currentFav._id === id ?
      [currentFav, ...all] :
      [...all, currentFav]
  ), []);

  favorites.splice(rank, 0, changedFavorite);

  const reorderedFavorites = favorites.map((favorite, index) => ({
    ...favorite,
    rank: index + 1,
  }));

  dispatch({
    type: UPDATE_USER_FAVORITES,
    favorites: reorderedFavorites,
  });

  const { details: userDetails } = getState();

  try {
    // Update favorites on API.
    const { message } = await userApi.updateUserFavorites(
      { favorites: reorderedFavorites },
      userDetails,
    );

    if (!message || message !== 'OK') {
      throw new Error(message || 'Error updating favorites');
    }
  } catch ({ message: error }) {
    // notify with failure action
    dispatch({
      type: UPDATE_USER_FAVORITES_FAILURE,
      error,
    });

    // update state from currentFavorites (the backup)
    dispatch({
      type: UPDATE_USER_FAVORITES,
      favorites: currentFavorites,
    });
  }
};

export const deleteUserFavorite = id => async (dispatch) => {
  dispatch({ type: DELETE_USER_FAVORITE });

  try {
    const { message } = await userApi.deleteUserFavorite(id);

    if (message && message === 'OK') {
      dispatch({
        type: DELETE_USER_FAVORITE_SUCCESS,
        id,
      });
    } else {
      throw new Error('Error deleting favorite');
    }
  } catch ({ message: error }) {
    dispatch({
      type: DELETE_USER_FAVORITE_FAILURE,
      error,
    });
  }
};

export const fetchPaymentWarnings = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENT_WARNINGS });
  try {
    let warningType;
    const warnings = await userApi.fetchPaymentWarnings();
    const filteredWarnings = warnings && warnings.filter(({ type, planId }) => {
      if ((type === 'invalidZip') || (type === 'failedPayment' && planId.startsWith('bw'))) {
        return true;
      }
      return false;
    });
    const warningTypes = filteredWarnings.map(({ type }) => type);
    if (warningTypes.includes('invalidZip')) warningType = 'invalidzip';
    if (warningTypes.includes('failedPayment')) warningType = 'failedpayment';
    dispatch({
      type: FETCH_PAYMENT_WARNINGS_SUCCESS,
      warningType,
    });
  } catch (err) {
    dispatch({
      type: FETCH_PAYMENT_WARNINGS_FAILURE,
      error: err,
    });
  }
};

export const fetchUserSettings = countryCode => async (dispatch) => {
  dispatch({ type: FETCH_USER_SETTINGS });

  try {
    const settings = await userApi.fetchUserSettings(countryCode);
    dispatch({
      type: FETCH_USER_SETTINGS_SUCCESS,
      settings,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_SETTINGS_FAILURE,
      error: err,
    });
  }
};

export const setUserLocation = location => async (dispatch) => {
  dispatch({ type: SET_USER_LOCATION });

  try {
    dispatch({
      type: SET_USER_LOCATION_SUCCESS,
      location,
    });
  } catch (err) {
    dispatch({
      type: SET_USER_LOCATION_FAILURE,
      error: err,
    });
  }
};

export const setUserBwWindWaveModel = bwWindWaveModel => async (dispatch, getState) => {
  const { user } = getState();
  const loggedIn = !!user.details;

  dispatch({ type: SET_USER_BW_WIND_WAVE_MODEL });

  try {
    if (!loggedIn) {
      cookie.save('bw_wind_wave_model', bwWindWaveModel, {
        path: '/',
        domain: location.hostname,
        maxAge: 31536000, // 1 year
        expires: new Date((new Date()).getTime() + (31536000 * 1000)),
      });
    } else {
      await userApi.updateUserSettings({
        bwWindWaveModel,
      });
    }
    dispatch({
      type: SET_USER_BW_WIND_WAVE_MODEL_SUCCESS,
      bwWindWaveModel,
    });
  } catch (error) {
    dispatch({
      type: SET_USER_BW_WIND_WAVE_MODEL_FAILURE,
      error,
    });
  }
};

export const setUserBwUnitPreference = bwUnitPreference => async (dispatch) => {
  dispatch({ type: SET_USER_BW_UNIT_PREFERENCE });

  try {
    await userApi.updateUserSettings({
      bwUnitPreference,
    });
    dispatch({
      type: SET_USER_BW_UNIT_PREFERENCE_SUCCESS,
      bwUnitPreference,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: SET_USER_BW_UNIT_PREFERENCE_FAILURE,
      error,
    });
  }
};

export const setDFPAdAttributes = (reqUrl, reqQuery) => async (dispatch) => {
  dispatch({ type: SET_DFP_AD_ATTRIBUTES });
  try {
    const adTargets = [];
    const URLArray = ['BW_URL', reqUrl];
    adTargets.push(URLArray);
    const { qaFlag } = reqQuery;
    if (qaFlag) adTargets.push(['BW_qaFlag', qaFlag]);
    let pageType = 'Home';
    if (reqUrl.includes('forecast/marine-weather')) {
      pageType = 'Forecast';
      adTargets.push(['BW_contentKeyword', 'seakeeperlogodec15']);
    }
    if (reqUrl.includes('map')) {
      pageType = 'Map';
    }
    adTargets.push(['BW_pageType', pageType]);
    const adAttributes = {
      adTargets,
    };
    dispatch({
      type: SET_DFP_AD_ATTRIBUTES_SUCCESS,
      adAttributes,
    });
  } catch (err) {
    dispatch({
      type: SET_DFP_AD_ATTRIBUTES_FAILURE,
      error: err,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/user.js